import { Badge } from '@/components/ui/badge';
import type { EmailKeyUserRow } from '@/lib/users-roles/types';
import { getProblemKind } from '@/lib/users-roles/problem-filter';

export function LifecycleBadge({ row }: { row: EmailKeyUserRow }) {
  const kind = getProblemKind(row);
  switch (kind) {
    case 'deleted':
      return <Badge variant="destructive">Deleted</Badge>;
    case 'invited-not-signed-in':
      return <Badge variant="secondary">Invited, not yet signed in</Badge>;
    case 'auth-disabled-without-deleted':
      return <Badge variant="outline">Auth disabled</Badge>;
    case 'fallback':
      return <Badge variant="outline">Legacy fallback</Badge>;
    default:
      return <Badge variant="outline" className="text-success-text">Existing</Badge>;
  }
}
